/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { useMediaQuery } from "react-responsive";
import TitleAndPagination from "../components/Pagination";
import SearchTable from "../components/SeachTable";
import CustomSearch from "../components/CustomSearch";
import { searchVehicles } from "../services/btc-api.service";
import { useSelector } from "react-redux";
import { initUserSession } from "../services/auth.service";

export default function SearchedItems() {
  const [limit, setLimit] = useState(20);
  const [offset, setOffSet] = useState(0);
  const [fromAnotherPage, setFromAnotherPage] = useState(0);
  const user = useSelector((state) => state.user.user);
  const [expanded, setExpanded] = useState(false);

  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const location = useLocation();
  const [searchResults, setSearchResults] = useState([]);
  const [searchObj, setSearchObj] = useState({
    maker: null,
    model: "",
    auctionType: null,
    stock: "",
    yearsStart: 1960,
    yearsEnd: 2023,
    color: null,
    condition: null,
    mileageStart: 0,
    mileageEnd: 100000,
    fuelType: null,
    bodyType: null,
    priceStart: 0,
    priceEnd: 10000000,
    steeringWheel: null,
    drivingSystem: null,
    transmission: null,
  });

  const handleLimit = (e) => {
    setLimit(e);
  };

  const onClickReset = () => {
    setSearchObj({
      maker: null,
      model: "",
      auctionType: null,
      stock: "",
      yearsStart: 1960,
      yearsEnd: 2023,
      color: null,
      condition: null,
      mileageStart: 0,
      mileageEnd: 100000,
      fuelType: null,
      bodyType: null,
      priceStart: 0,
      priceEnd: 10000000,
      steeringWheel: null,
      drivingSystem: null,
      transmission: null,
    });
  };

  const handlePageChange = (e) => {
    setOffSet(e);
  };

  const loadData = async (obj, collapse = undefined) => {
    setFromAnotherPage(1);
    const objToSend = { ...obj };

    if (objToSend.maker) {
      objToSend.maker = objToSend.maker._id ?? null;
    }

    if (objToSend.auctionType) {
      objToSend.auctionType = objToSend.auctionType.code ?? null;
    }

    if (objToSend.condition) {
      objToSend.condition = objToSend.condition.code ?? null;
    }

    if (objToSend.fuelType) {
      objToSend.fuelType = objToSend.fuelType.code ?? null;
    }

    if (objToSend.bodyType) {
      objToSend.bodyType = objToSend.bodyType.code ?? null;
    }

    if (objToSend.color) {
      objToSend.color = objToSend.color.code ?? null;
    }

    if (!objToSend.page) {
      objToSend["page"] = offset;
    }

    if (!limit) {
      objToSend["limit"] = 20;
    } else {
      objToSend["limit"] = limit;
    }

    if (user && user._id) {
      objToSend["userId"] = user?._id;
    }

    searchVehicles(objToSend).then((res) => {
      setSearchResults(res);

      if (collapse) {
        setExpanded(false);
      }
    });
  };

  useEffect(() => {
    if (fromAnotherPage === 2) {
      if (location && location.state && location.state.vehicles) {
        setSearchResults({
          ...location.state.vehicles,
          totalPages: location.state.vehicles.totalPages > 1 ? 1 : 1,
          totalRecords:
            location.state.vehicles.totalRecords > 10
              ? 10
              : location.state.vehicles.totalRecords,
        });
      }
    }
  }, [fromAnotherPage]);

  useEffect(() => {
    if (location && location.state && location.state.vehicles) {
      setFromAnotherPage(2);
    } else {
      const queryParams = new URLSearchParams(location.search);
      const queryParamsObj = Object.fromEntries(queryParams.entries());
      queryParamsObj["page"] = offset;
      queryParamsObj["limit"] = limit;
      const id = localStorage.getItem("id");
      queryParamsObj["userId"] = user && user._id ? user._id : id ? id : null;

      if (queryParamsObj.country) {
        setSearchObj({
          ...searchObj,
          country: queryParamsObj.country,
        });
      }

      if (queryParamsObj.maker) {
        setSearchObj({
          ...searchObj,
          maker: queryParamsObj.maker,
        });
      }

      if (queryParamsObj.searchText) {
        setSearchObj({
          ...searchObj,
          searchText: queryParamsObj.searchText,
        });
      }

      if (queryParamsObj.auctionType) {
        setSearchObj({
          ...searchObj,
          auctionType: queryParamsObj.auctionType,
        });
      }
      queryParamsObj.priceStart = searchObj.priceStart;
      queryParamsObj.priceEnd = searchObj.priceEnd;
      queryParamsObj.yearsStart = searchObj.yearsStart;
      queryParamsObj.yearsEnd = searchObj.yearsEnd;
      queryParamsObj.mileageStart = searchObj.mileageStart;
      queryParamsObj.mileageEnd = searchObj.mileageEnd;
      searchVehicles(queryParamsObj).then((res) => {
        setSearchResults(res);
      });
    }
  }, []);

  useEffect(() => {
    if (location && location.state && location.state.vehicles) {
      setFromAnotherPage(2);
    } else {
      setFromAnotherPage(1);
      const queryParams = new URLSearchParams(location.search);
      const queryParamsObj = Object.fromEntries(queryParams.entries());
      queryParamsObj["page"] = offset;
      queryParamsObj["limit"] = limit;
      const id = localStorage.getItem("id");
      queryParamsObj["userId"] = user && user._id ? user._id : id ? id : null;

      if (queryParamsObj.country) {
        setSearchObj({
          ...searchObj,
          country: queryParamsObj.country,
        });
      }

      if (queryParamsObj.maker) {
        setSearchObj({
          ...searchObj,
          maker: queryParamsObj.maker,
        });
      }

      if (queryParamsObj.searchText) {
        setSearchObj({
          ...searchObj,
          searchText: queryParamsObj.searchText,
        });
      }

      if (queryParamsObj.auctionType) {
        setSearchObj({
          ...searchObj,
          auctionType: queryParamsObj.auctionType,
        });
      }

      queryParamsObj.priceStart = searchObj.priceStart;
      queryParamsObj.priceEnd = searchObj.priceEnd;
      queryParamsObj.yearsStart = searchObj.yearsStart;
      queryParamsObj.yearsEnd = searchObj.yearsEnd;
      queryParamsObj.mileageStart = searchObj.mileageStart;
      queryParamsObj.mileageEnd = searchObj.mileageEnd;

      searchVehicles(queryParamsObj).then((res) => {
        setSearchResults(res);
      });
    }
  }, [location.search]);

  useEffect(() => {
    if (fromAnotherPage === 1) {
      loadData({ ...searchObj, page: offset, limit: limit });
    }
  }, [limit, offset]);

  return (
    <div>
      <div>
        {expanded === false && (
          <div className="btn-wrapper-custom-search">
            <button
              className="search-custom-btn-1"
              onClick={() => {
                setExpanded(!expanded);
              }}
            >
              {" "}
              Custom Search{" "}
              {expanded ? (
                <span>
                  <i className="fa fa-angle-up" />
                </span>
              ) : (
                <span>
                  <i className="fa fa-angle-down" />
                </span>
              )}{" "}
            </button>
          </div>
        )}
        <CustomSearch
          expanded={expanded}
          setExpanded={setExpanded}
          onSearch={loadData}
          searchObj={searchObj}
          setSearchObj={setSearchObj}
          onClickReset={onClickReset}
          collapse={true}
        />
        <div className="auction-page  container-fluid">
          <TitleAndPagination
            handlePageChange={handlePageChange}
            handleLimit={handleLimit}
            title={"Search Results"}
            totalRecords={
              searchResults && searchResults.totalRecords
                ? searchResults.totalRecords
                : 0
            }
            limit={limit}
          />

          {searchResults &&
            searchResults.records &&
            searchResults.records.length > 0 && (
              <SearchTable
                loadData={loadData}
                rows={searchResults.records}
                isMobile={isMobile}
                style={{ paddingLeft: isMobile ? 10 : 40, marginTop: 50 }}
                rowColor
              />
            )}
        </div>
      </div>
    </div>
  );
}
